import { useEffect, useState } from "react";
import RollingHeader from "./components/RollingHeader";
import RollingTable from "./components/RollingTable";
import "./components/Rolling.css";
import { getAllUsers, getRollingReserve } from "../../config/LiveApi";
import Spinner from "../Spin/Spinner";
import { useSelector } from "react-redux";
import Pagination from "./components/Pagination";

function RollingReserve() {
  let token = useSelector((store) => store.userReducer.token);
  const [dataItem, setDataItem] = useState(null);
  const [loading, setLoading] = useState(false);
  const [userData, setUserData] = useState(null);
  const [pagesData, setPagesData] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);

  const role = useSelector((store) => store.userReducer.role);

  const getRollingReserveData = async (token, currentPage) => {
    setLoading(true);
    const data = await getRollingReserve(token, currentPage);
    setDataItem(data.data);
    setPagesData(data.meta?.pagination?.totalPages);
    setLoading(false);
  };

  const fetchUsers = async () => {
    try {
      if (role === "admin" || role === "subAdmin") return;
      const response = await getAllUsers(token, currentPage);
      const data = response?.data;

      setUserData(data);
    } catch (error) {
      console.log(error.message);
    }
  };

  useEffect(() => {
    fetchUsers();
    getRollingReserveData(token, currentPage);
  }, []);

  return (
    <div>
      <RollingHeader />
      <div className="mar-top-rol">
        {loading ? (
          <Spinner />
        ) : (
          dataItem &&
          dataItem.length > 0 && (
            <RollingTable
              dataItem={dataItem}
              userData={userData}
              setCurrentPage={setCurrentPage}
              currentPage={currentPage}
              pagesData={pagesData}
              getRollingReserveData={getRollingReserveData}
            />
          )
        )}
        {dataItem && dataItem.length === 0 && (
          <div className="table-main-report">
            <table className="table-user-management" id="transaction-table">
              <thead className="table-user-report">
                <tr>
                  {(role == "super" || role === "operation") && (
                    <td>
                      <p className="user-table-head-report">Business Name</p>
                    </td>
                  )}

                  <td>
                    <p className="user-table-head-report">OrderId</p>
                  </td>
                  <td>
                    <p className="user-table-head-report">TransactionId</p>
                  </td>
                  <td>
                    <p className="user-table-head-report">Amount(₹)</p>
                  </td>
                  <td>
                    <p className="user-table-head-report"> Date</p>
                  </td>
                  <td>
                    <p className="user-table-head-report">Days Left</p>
                  </td>
                  <td>
                    <p className="user-table-head-report">Status</p>
                  </td>
                </tr>
              </thead>
            </table>
          </div>
        )}

        {dataItem && dataItem.length === 0 && (
          <>
            <div className="no-data">No Rolling Reserve Available</div>
            <Pagination
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              pagesData={pagesData}
              getRollingReserveData={getRollingReserveData}
              token={token}
            />
          </>
        )}
      </div>
    </div>
  );
}

export default RollingReserve;
